import * as Logger from "js-logger";
import "pixi.js";
import FooterComponent from "slotworks/components/info/footer-component";
import GameLoop from "slotworks/core/game-loop";
import ButtonElement, { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { MultiStyleText } from "slotworks/graphics/pixi/pixi-multistyle-text";
import RevolverBuilders from "slotworks/integration/revolver/revolver-builders";
import { RevolverInit, RevolverReady} from "slotworks/integration/revolver/revolver-setup";
import SlotWorks from "slotworks/slotworks";
import HiddenButtonBehaviour from "slotworks/smart-button/behaviours/hidden-button-behaviour";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import StateMachine from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import { EnableOnScreenErrors } from "slotworks/utils/debug";
import BigWinComponent from 'slotworks/components/bigwin/big-win-component';
import Components from "slotworks/components/components";
import FreespinButtonBehaviour from "slotworks/smart-button/behaviours/freespin-button-behaviour";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import soundManager from "slotworks/sound/sound-manager";
import graphicsManager from "slotworks/graphics/graphics-manager";
import gameState from "slotworks/model/game-state";
import BuilderManager from "slotworks/server/builders/builder-manager";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import G288Init from "states/init";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import AuthRecordBuilder from "slotworks/integration/revolver/builders/records/auth-record-builder";
import G288AuthRecordBuilder from "integration/builders/auth-record-builder";
import G288SpinRecordBuilder from "integration/builders/spin-record-builder";
import BigWinTransitions from "transitions/big-win-transitions";
import MegaWinTransitions from "transitions/mega-win-transitions";
import SuperMegaWinTransitions from "transitions/super-mega-win-transitions";
import EpicWinTransitions from "transitions/epic-win-transitions";
import WayResultBuilder from "integration/builders/way-result-builder";
import ShowWins from "states/show-wins";
import TotalWinTransitions from "slotworks/integration/revolver/transitions/total-win-transitions";
import LineWinTransitions from "slotworks/integration/revolver/transitions/line-win-transitions";
import SpinRecordBuilder from "slotworks/integration/revolver/builders/records/spin-record-builder";
import FreespinsPlaqueTransitions from "transitions/freespins-plaque-transitions";
import RecoveryRecordBuilderBase from "slotworks/integration/revolver/builders/records/recovery-record-builder-base";
import G288EnterFreespins from "states/enter-freespins";
import G288ExitFreespins from "states/exit-freespins";
import StackFeature from "states/stack-feature";
import LowToHigh from "states/low-to-high";
import IsStackFeatureDecision from "decisions/is-stack-feature";
import animationManager from "slotworks/graphics/animation/animation-manager";
import IntroAnimationFactory from "animations/intro-animation-factory";
import IsStackAddAndFreespins from "decisions/is-stack-add-freespins";
import SwedenTopBar from "slotworks/integration/revolver/regulations/sweden/responsible-gambling-links";
import FreespinsBannerTransitions from "transitions/freespins-banner-transitions";
import BannerComponent from "slotworks/components/banner/banner-component";
import G288BigWins from "states/big-wins";
import G288FreespinsRetriggered from "decisions/freespins-retriggered";
import G288RetriggerFreespins from "states/retrigger-freespins";
import G288EnterRecoveryFreespins from "states/enter-recovery-freespins";
import Autoplay from "slotworks/state-machine/standard/states/autoplay";
import G288LoopWins from "states/loop-wins";
import G288RequestSpin from "states/request-spin";
import G288RequestFreespin from "states/request-freespin";
import { AnimatedParticle } from "pixi-particles";
import G288Spin from "states/spin";
import settingsModel from "slotworks/model/settings/settings-model";

declare const __DEBUG__: boolean;
declare const require: any;
const assetConfig = require("./asset-config.json");
const gameConfig = require("./game-config.json");
const stateConfig = require("./state-config.json");
const soundConfig = require("./sound-config.json");
const componentConfig = require("./component-config.json");
const i18nConfig = require("./i18n-config.json");

require("../static/styles.scss");

if (__DEBUG__) {
    Logger.useDefaults();
}

RevolverInit();

AnimatedParticle.prototype.init = function()
{
    this.Particle_init();

    this.elapsed = 0;

    //if the animation needs to match the particle's life, then cacluate variables
    if(this.framerate < 0)
    {
        this.duration = this.maxLife;
        this.framerate = this.textures.length / this.duration;
    }

    // if(this.loop) {
    //     this.elapsed = Math.random() * this.duration;
    // }
}

AnimatedParticle.prototype.update = function (delta) {
    var lerp = this.Particle_update(delta);
    //only animate the particle if it is still alive
    if (lerp >= 0) {
        this.elapsed += delta;
        if (this.elapsed > this.duration) {
            //loop elapsed back around
            if (this.loop)
                this.elapsed = this.elapsed % this.duration;
            else
                this.elapsed = this.duration - 0.000001;
        }
        var frame = (this.elapsed * this.framerate + 0.0000001) | 0;
        this.texture = this.textures[frame] || PIXI.Texture.EMPTY;
    }
    return lerp;
};

settingsModel.jurisdictionSetLanguage = false;

const ready = () => {
    // (<any>window).Components = Components;
    // (<any>window).Layers = Layers;
    // (<any>window).GameState = gameState;
    // (<any>window).GameLoop = GameLoop;
    // (<any>window).graphicsManager = graphicsManager;
    // (<any>window).smart = SmartButton;
    // (<any>window).sound = soundManager;
    // (<any>window).cvm = canvasManager;

    setupTransitions();

    // FreespinIdle.WAIT = 1000;
    Autoplay.WAIT = 1000;

    MultiStyleText.autoShrink = true;
    MultiStyleText.debugOptions.autoShrink.enabled = true;

    animationManager.addScriptedAnimationFactory("intro_preview", new IntroAnimationFactory());

    if (__DEBUG__) {
        GameLoop.showStats();
    }

    RevolverReady();
    (GameLoop as any).frameSkipping = true;

    ButtonElement.DISABLED_TINT = 0xA9A9A9;
    ButtonElement.OVER_TINT = 0xd3d3d3;
    ButtonElement.DOWN_SCALE = 0.8;
    BannerComponent.loopTime = 2000000; // no loop

    FreespinButtonBehaviour.HIDDEN = false;
};

const setupComms = () => {
    revolverModel.addFreespinIdentifiers(["FREE_SPINS"]);
    RevolverBuilders.init();

    BuilderManager.removeRecordBuilder(AuthRecordBuilder);
    BuilderManager.addRecordBuilder(G288AuthRecordBuilder);
    BuilderManager.removeRecordBuilder(SpinRecordBuilder);
    BuilderManager.addRecordBuilder(G288SpinRecordBuilder);
    BuilderManager.addRecordBuilder(new RecoveryRecordBuilderBase());
    BuilderManager.addResultBuilder(WayResultBuilder);
};

const setupStates = () => {
    StateRegister.add("g288-init", new G288Init(StateMachine));
    StateRegister.add('g288-show-win-lines', new ShowWins(StateMachine));
    StateRegister.add('g288-enter-freespins', new G288EnterFreespins(StateMachine));
    StateRegister.add('g288-retrigger-freespins', new G288RetriggerFreespins(StateMachine));
    StateRegister.add('g288-exit-freespins', new G288ExitFreespins(StateMachine));
    StateRegister.add('stack-feature', new StackFeature(StateMachine));
    StateRegister.add('low-to-high', new LowToHigh(StateMachine));
    StateRegister.add('big-win-before-freespins', new G288BigWins(StateMachine));
    StateRegister.add('g288-big-wins', new G288BigWins(StateMachine));
    StateRegister.add('g288-enter-recovery-freespins', new G288EnterRecoveryFreespins(StateMachine));
    StateRegister.add('g288-loop-wins', new G288LoopWins(StateMachine));
    StateRegister.add('g288-request-spin', new G288RequestSpin(StateMachine));
    StateRegister.add('g288-request-freespin', new G288RequestFreespin(StateMachine));
    StateRegister.add('g288-spin', new G288Spin(StateMachine));

    StateRegister.add('is-stack-feature', new IsStackFeatureDecision());
    StateRegister.add('is-stack-feature-freespins', new IsStackAddAndFreespins());
    StateRegister.add('g288-freespins-retriggered', new G288FreespinsRetriggered());
    
};

const setupTransitions = () => {
    BigWinComponent.CLICK_TO_SKIP = true;
    BigWinComponent.HANG_TIME = 3000;
    SwedenTopBar.RESIZE_DOWN_ON_PORTRAIT = false;

    Layers.CelebrationContent.setTransitions("totalWin", new TotalWinTransitions());
    Layers.CelebrationContent.setTransitions("lineWin", new LineWinTransitions());
    Layers.CelebrationContent.setTransitions("additionalWin", new LineWinTransitions());

    Layers.Prompts.setTransitions("freespinswin", new FreespinsPlaqueTransitions());
    Layers.Prompts.setTransitions("freespinsretrigger", new FreespinsPlaqueTransitions());
    Layers.Prompts.setTransitions("freespinssummary", new FreespinsPlaqueTransitions());
    Layers.Banners.setTransitions("freespins", new FreespinsBannerTransitions());
    
    Layers.CelebrationContent.setTransitions("bigWin", new BigWinTransitions());
    Layers.CelebrationContent.setTransitions("megaWin", new MegaWinTransitions());
    Layers.CelebrationContent.setTransitions("superMegaWin", new SuperMegaWinTransitions());
    Layers.CelebrationContent.setTransitions("epicWin", new EpicWinTransitions());
};

setupComms();
setupStates();

SlotWorks.go(gameConfig, stateConfig, assetConfig, componentConfig, soundConfig, i18nConfig, ready);

if (__DEBUG__) {
    EnableOnScreenErrors();
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/app.ts